import * as amplitude from "@amplitude/analytics-browser";

let initialized = false;
let identified = false;
const queuedUserProperties = {};
const queuedEvents = [];

export function initAmplitude({ apiKey, userId } = {}) {
  if (initialized || !apiKey) {
    return;
  }
  amplitude.init(apiKey, userId || undefined, {
    defaultTracking: { sessions: true, pageViews: false, formInteractions: false, fileDownloads: false }
  });
  initialized = true;

  if (Object.keys(queuedUserProperties).length > 0) {
    setAmplitudeUserProperties(queuedUserProperties);
  }
  queuedEvents.splice(0).forEach(([eventName, properties]) => amplitude.track(eventName, properties));
}

export function identifyAmplitudeUser(userId, userProperties = {}) {
  if (!userId) {
    return;
  }
  if (!initialized) {
    Object.assign(queuedUserProperties, userProperties);
    return;
  }
  amplitude.setUserId(String(userId));
  setAmplitudeUserProperties(userProperties);
  identified = true;
}

export function setAmplitudeUserProperties(properties = {}) {
  if (!initialized) {
    Object.assign(queuedUserProperties, properties);
    return;
  }
  const id = new amplitude.Identify();
  Object.entries(properties).forEach(([k, v]) => {
    if (v !== undefined && v !== null) id.set(k, v);
  });
  amplitude.identify(id);
}

export function trackAmplitudeEvent(eventName, properties = {}) {
  if (window.testEnv) {
    window.amplitudeEventCalls = window.amplitudeEventCalls || [];
    window.amplitudeEventCalls.push([eventName, properties]);
    return;
  }
  if (!initialized) {
    queuedEvents.push([eventName, properties]);
    return;
  }
  amplitude.track(eventName, properties);
}

export function isAmplitudeIdentified() {
  return identified;
}
